module.exports = __webpack_public_path__ + "static/media/vehicle.60a6bdba.svg";